/* eslint-disable react/jsx-no-bind */
/* eslint-disable no-empty-pattern */
/* eslint-disable react/prop-types */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { useNavigate } from 'react-router-dom';
import { DynamicConditionFormValues } from '../../types/DynamicCondition.types';
import * as yup from 'yup';
import { useCallback, useEffect, useState } from 'react';
import { OptionType, Select } from '../../components/Form/Select';
import { ConditionData, SingleConditionData } from '../../types/Condition.types';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { PlusIcon, XMarkIcon } from '@heroicons/react/24/outline';
import Box from '../../components/Box';
import Button from '../../components/Form/Button';
import FormGroup from '../../components/Form/FormGroup';
import Heading from '../../components/Text/Heading';
import Paragraph from '../../components/Text/Paragraph';
import { getBadge } from '../Documents/utils';
import { DialogConfirmAction } from '../shared/DialogConfirmAction';
import { DynamicConditionContainer, Steps, StyledFormDynamic } from './styles';
import { conditionService } from '../../api/services';
import BlankCircle from '../../assets/icons/blank-circle.svg';
import Mocado from './dataOpen.json';
import { SingleVariableData } from '../../types/Variable.types';

interface DynamicConditionForm {
  initialData?: DynamicConditionFormValues;
  relationType?: string;
  type?: string;
  onSubmit: (data: DynamicConditionFormValues) => void;
}

const validationSchema = yup.object({
  principalConditionId: yup.string().required('A condição do campo principalConditionId é obrigatório'),
  listDepedentCondition: yup
    .array()
    .of(
      yup.object().shape({
        dependentConditionId: yup.object().shape({
          label: yup.string().required('A escolha da condição depedente é obrigatório'),
          value: yup.string().required(),
        }),
        values: yup
          .array()
          .of(
            yup.object().shape({
              principalConditionValue: yup.object().shape({
                label: yup.string().required('O valor da condição principal é obrigatório'),
                value: yup.string().required(),
              }),
              dependentConditionValue: yup.object().shape({
                label: yup.string().required('O valor da condição dependente é obrigatório'),
                value: yup.string().required(),
              }),
            })
          )
          .min(1, 'É necessária pelo menos uma associação de valores.'),
      })
    )
    .min(1, 'É necessário selecionar pelo menos uma condição dependente.'),
});

const DynamicConditionForm = ({ initialData, relationType, type, onSubmit }: DynamicConditionForm) => {
  //Utilidades
  const [loading, setLoading] = useState<boolean>(true);
  const [search, setSearch] = useState<string>('');
  const navigate = useNavigate();
  const navigateToConditions = useCallback(() => {
    navigate(`/conditions`);
  }, []);

  //Declarações
  const [principalCondition, setPrincipalCondition] = useState<ConditionData>(); //Condicao principal
  const [principalConditionOptions, setPrincipalConditionOptions] = useState<readonly OptionType[]>(); //Condicao principal
  const [ListConditionOptionsPrincipal, setListConditionOptionsPrincipal] = useState<Array<readonly OptionType[]>>(); //Condicao principal
  const [listDependentConditionOptions, setListDependentConditionOptions] = useState<Array<readonly OptionType[]>>([]); //Uma lista das opcoes de cada condicao, onde o indice representa a quem pertence.
  const [listConditionOptions, setListConditionsOptions] = useState<readonly OptionType[]>();
  const [listSearchConditions, setListSearchConditions] = useState<ConditionData[]>();

  const {
    control,
    watch,
    handleSubmit,
    getValues,
    setValue,
    formState: { errors },
  } = useForm<DynamicConditionFormValues>({
    defaultValues: initialData,
    resolver: yupResolver(validationSchema),
  });
  const { fields, append, remove } = useFieldArray({
    name: 'listDepedentCondition',
    control,
  });
  const watchListDepedent = watch('listDepedentCondition');

  const appendValue = useCallback(() => {
    append({
      dependentConditionId: {
        label: '',
        value: '',
      },
      values: [
        {
          principalConditionValue: {
            label: '',
            value: '',
          },
          dependentConditionValue: {
            label: '',
            value: '',
          },
        },
      ],
    });
  }, [append]);

  //Realizar a busca no banco de dados
  const handleSearch = useCallback((newValue: string) => {
    setSearch(newValue);
  }, []);

  const removeCondition = useCallback(
    (index: number) => {
      remove(index);
    },
    [remove]
  );

  const renderSelectPrincipalCondition = useCallback(
    (field: any, valueIndex: number) => {
      let list = principalConditionOptions;
      const valoresJaSalvos = getValues(`listDepedentCondition.${valueIndex}.values`);
      // Filtra a lista com base nos valores já salvos
      if (valoresJaSalvos != undefined && principalConditionOptions != undefined && valoresJaSalvos?.length > 0) {
        list = principalConditionOptions.filter((option) => {
          return !valoresJaSalvos?.some((salvo) => salvo.principalConditionValue.value === option.value);
        });
      }

      return <Select {...field} placeholder="Selecione uma opção" options={list} />;
    },
    [principalConditionOptions, listDependentConditionOptions]
  );

  const renderSelectDependentCondition = useCallback(
    (field: any, index: number) => {
      return <Select {...field} placeholder="Selecione uma opção" options={listDependentConditionOptions[index]} />;
    },
    [listDependentConditionOptions]
  );

  const fetchData = async () => {
    try {
      const result = await conditionService.listPaged({
        pagination: { skip: 0, limit: 5 },
        sort: { field: 'dataCriacao', order: 'DESC' },
        query: search,
      });

      if (result) {
        if (listSearchConditions != null && listSearchConditions.length > 0) {
          setListSearchConditions(() => {
            // const existingIds = new Set(
            //   listConditionOptions?.map((option) => option.value).filter((id) => id !== undefined) as string[]
            // );
            // // Filtra `listSearch` para manter apenas os elementos que ainda existem em `listConditionOptions`
            // const filterEl = listSearch?.filter((el) => el.idModeloCondicao && existingIds.has(el.idModeloCondicao));
            // const updatedConditions = [...(filterEl ?? [])];
            // return updatedConditions;

            const updatedConditions = [...result.data];
            return updatedConditions;
          });
        } else {
          setListSearchConditions(result.data);
        }
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  //Realizar a busca da variável depedente uma vez que foi selecionada.
  const getDependentCondition = useCallback(
    async (value: string, index: number) => {
      const dependentConditionData = await conditionService.getById(value);
      if (dependentConditionData != null) {
        setListDependentConditionOptions((prevList) => {
          const updatedList = [...prevList];
          const listOption =
            dependentConditionData?.condicaoOpcoes
              ?.filter((option) => option.descricao && option.idModeloCondicaoOpcao)
              .map((option) => ({
                label: option.descricao as string,
                value: option.idModeloCondicaoOpcao as string,
              })) || [];

          updatedList[index] = listOption;
          return updatedList;
        });

        const newValue = {
          principalConditionValue: {
            label: '',
            value: '',
          },
          dependentConditionValue: {
            label: '',
            value: '',
          },
        };
        setValue(`listDepedentCondition.${index}.values`, [newValue]);
      }

      const updatedConditions = listConditionOptions?.filter((el) => el.value && el.value != value);
      setListConditionsOptions(updatedConditions);
    },
    [setListDependentConditionOptions]
  );

  //Uma função que é responsavel, por mostrar as condicoes que não são depententes e nem principal que podem ser selecionadas.
  const renderSelectConditionsOptions = useCallback(
    (field: any, index: number) => (
      <Select
        placeholder="Selecione uma opção"
        disabled={relationType === 'Dependente'} //Não precisa se preocupar com a principal que no options é filtrado.
        {...field}
        onInputChange={handleSearch}
        onChange={(element) => {
          field.onChange(element);
          getDependentCondition(element.value, index);
        }}
        options={listConditionOptions}
      />
    ),
    [listConditionOptions]
  );

  const appendVinculo = useCallback(
    (index: number) => {
      const listValues = getValues(`listDepedentCondition.${index}.values`) || [];

      const newValue = {
        principalConditionValue: {
          label: '',
          value: '',
        },
        dependentConditionValue: {
          label: '',
          value: '',
        },
      };
      const updatedValues = [...listValues, newValue];
      setValue(`listDepedentCondition.${index}.values`, updatedValues);
    },
    [getValues, setValue]
  );

  const deleteAndReorganizeArrayAtIndex = <T,>(array: T[], index: number): T[] => {
    return [...array.slice(0, index), ...array.slice(index + 1)];
  };

  const removeDependentConditionAndValues = useCallback(
    (indexDependent: number, indexValue: number) => {
      const listValues = getValues(`listDepedentCondition.${indexDependent}.values`);
      if (listValues !== undefined && listValues?.length > 0) {
        const updatedValues = listValues.filter((_, idx) => idx !== indexValue);

        //Remover proxima linha
        setListSearchConditions((prev) => deleteAndReorganizeArrayAtIndex(prev ?? [], indexValue));
        if (updatedValues.length > 0) {
          setValue(`listDepedentCondition.${indexDependent}.values`, updatedValues);
        } else {
          setValue(`listDepedentCondition.${indexDependent}.values`, [
            {
              principalConditionValue: {
                label: '',
                value: '',
              },
              dependentConditionValue: {
                label: '',
                value: '',
              },
            },
          ]);
        }
      }
    },
    [getValues, setValue]
  );

  useEffect(() => {
    async function getPrincipalCondition() {
      if (initialData != null) {
        const resultConditionPrincipal = await conditionService.getById(initialData.principalConditionId);
        setPrincipalCondition(resultConditionPrincipal);
        //setValue('principalConditionId', initialData.principalConditionId);

        //Carregar as condições dependentes que condição principal armazena
        if (initialData.listDepedentCondition != null && initialData.listDepedentCondition.length > 0) {
          const ListConditionSec = await Promise.all(
            initialData.listDepedentCondition.map(async (element) => {
              if (element.dependentConditionId != null) {
                return await conditionService.getById(element.dependentConditionId.value);
              }
            })
          );
          const filteredConditions = ListConditionSec.filter((el): el is SingleConditionData => el !== undefined);
          filteredConditions.forEach((element, index) => {
            setListDependentConditionOptions((prevList) => {
              const updatedList = [...prevList];
              const listOption =
                element?.condicaoOpcoes
                  ?.filter((option) => option.descricao && option.idModeloCondicaoOpcao)
                  .map((option) => ({
                    label: option.descricao as string,
                    value: option.idModeloCondicaoOpcao as string,
                  })) || [];

              updatedList[index] = listOption;
              return updatedList;
            });

            setValue(`listDepedentCondition.${index}.dependentConditionId`, {
              label: element.titulo ?? '',
              value: element.idModeloCondicao ?? '',
            });
          });
        } else {
          appendValue(); //Caso a condição principal não tenha vinculos com a condição secundária, inicialize pelo menos um vínculo vázio.
        }
      }
    }

    async function getInitialConditions() {
      const listPageConditions = await conditionService.listPaged({
        pagination: { skip: 0, limit: 15 },
        sort: { field: 'dataCriacao', order: 'DESC' },
        query: search,
      });

      /*
      if (
        initialData != null &&
        initialData.listDepedentCondition != null &&
        initialData.listDepedentCondition?.length > 0
      ) {
        initialData.listDepedentCondition.forEach((element, index) => {
          const findCondition = listPageConditions?.data?.find(
            (el) => el.idModeloCondicao === element.dependentConditionId?.value //Isso aqui pode esta errado;
          );

          // if (findCondition) {
          //   setValue(`listDepedentCondition.${index}.dependentConditionId`, {
          //     label: findCondition.titulo ?? '',
          //     value: findCondition.idModeloCondicao ?? '',
          //   });
          // }
        });
      }
      */
      setListSearchConditions(listPageConditions?.data);
      setLoading(false);
    }

    getPrincipalCondition();
    getInitialConditions();
  }, []);

  useEffect(() => {
    setPrincipalConditionOptions(
      principalCondition?.condicaoOpcoes
        ?.filter((option) => option.descricao && option.idModeloCondicao)
        .map((option) => ({
          label: option.descricao as string,
          value: option.idModeloCondicaoOpcao as string,
        }))
    );
  }, [principalCondition]);

  useEffect(() => {
    const conditionsOptions = listSearchConditions
      ?.filter(
        (element) =>
          element.idModeloCondicao !== initialData!.principalConditionId &&
          element.tipoRelacao !== 'Principal' &&
          element.tipoRelacao !== 'Dependente'
      )
      .map(
        (elCondition) =>
          ({
            label: elCondition.titulo,
            value: elCondition.idModeloCondicao,
          } as OptionType)
      );
    setListConditionsOptions(conditionsOptions);
  }, [listSearchConditions]);

  useEffect(() => {
    if (search.length < 3 && search.length != 0) {
      return;
    }
    const delayDebounceFn = setTimeout(() => {
      fetchData();
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [search]);

  return (
    <StyledFormDynamic onSubmit={handleSubmit(onSubmit)}>
      <DynamicConditionContainer>
        <Box
          padding={false}
          border={false}
          footer={
            <>
              <Button type="button" kind="alert" onClick={navigateToConditions}>
                Cancelar
              </Button>

              <Button type="submit">Finalizar</Button>
            </>
          }>
          <Box>
            <Steps>
              <div>
                <img src={BlankCircle} /> <Paragraph>Condição principal</Paragraph>
              </div>
              <div className="separator"></div>
              <div className="">
                <img src={BlankCircle} /> <Paragraph>Aplicação</Paragraph>
              </div>
            </Steps>
          </Box>
          <Box>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <Heading size="medium">Condição dinâmica</Heading>
              <Button type="button" kind="outline" style={{ width: '300px' }} onClick={appendValue}>
                <PlusIcon />
                Adicionar condição dependente.
              </Button>
            </div>

            <Paragraph>
              Aqui, você vinculará comportamentos de uma condição principal aos dados de uma ou mais condições
              dependentes. Se a condição dependente configurar variáveis, a condição principal também deverá afetá-las.
            </Paragraph>

            <div className="condition-info">
              <div>
                <Paragraph className="key">Nome da condição principal</Paragraph>
                <div className="value">{principalCondition?.titulo}</div>
              </div>
              <div style={{ marginInline: '10px' }}>
                <Paragraph className="key">Tipo</Paragraph>
                <div className="value">
                  {principalCondition?.tipoRelacao == undefined ? 'Comum' : principalCondition?.tipoRelacao}
                </div>
              </div>
              <div>
                <Paragraph className="key">Característica</Paragraph>
                <div className="value">{getBadge('principal' as string)}</div>
              </div>

              {principalCondition?.descricao != null && principalCondition?.descricao != '' && (
                // <div className="condition-info">
                <div>
                  <div style={{ marginTop: '10px' }}>
                    <Paragraph className="key">Descrição da condição</Paragraph>
                    <div className="value">{principalCondition?.descricao}</div>
                  </div>
                </div>
                // </div>
              )}
            </div>

            <div>
              <Heading size="medium">Lista de condições dependentes:</Heading>
              <div
                className="condition-info"
                style={{ height: '20px', padding: '0px', marginTop: '20px', marginBottom: '0px' }}></div>
            </div>

            {!loading &&
              fields.length > 0 &&
              fields.map((field, valueIndex) => (
                <div key={field.id}>
                  {' '}
                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'space-between',
                      alignItems: 'end',
                      marginTop: '25px',
                    }}>
                    <FormGroup
                      error={errors?.listDepedentCondition?.[valueIndex]?.dependentConditionId?.label?.message}>
                      <Paragraph className="label">Selecione uma condição dependente:</Paragraph>
                      <Controller
                        name={`listDepedentCondition.${valueIndex}.dependentConditionId`}
                        control={control}
                        render={({ field }) => renderSelectConditionsOptions(field, valueIndex)}
                      />
                    </FormGroup>

                    <DialogConfirmAction
                      type="delete"
                      trigger={
                        <Button type="button" kind="outline" style={{ width: '300px' }}>
                          <XMarkIcon />
                          Remover condição selecionada.
                        </Button>
                      }
                      title="Confirmar exclusão?"
                      text={`Tem certeza que deseja excluir essa condição depedente?`}
                      // eslint-disable-next-line react/jsx-no-bind
                      onConfirm={() => removeCondition(valueIndex)}
                    />
                  </div>
                  <div className="value-container" key={field.id}>
                    {watchListDepedent != null &&
                      watchListDepedent[valueIndex]?.values?.map((value, valueSubIndex) => (
                        <Box
                          className="value-container"
                          key={`${field.id}-${value.dependentConditionValue.value}-${valueSubIndex}`}>
                          <section style={{ marginTop: '5px' }}>
                            <div style={{ width: '350px' }}>
                              <FormGroup
                                error={
                                  errors?.listDepedentCondition?.[valueIndex]?.values?.[valueSubIndex]
                                    ?.principalConditionValue?.label?.message
                                }>
                                <Paragraph className="label">Valor da condição principal</Paragraph>
                                <Controller
                                  name={`listDepedentCondition.${valueIndex}.values.${valueSubIndex}.principalConditionValue`}
                                  control={control}
                                  render={({ field }) => renderSelectPrincipalCondition(field, valueIndex)}
                                />
                              </FormGroup>
                            </div>

                            <div className="value-separator">
                              <Paragraph size="small">Vincular à</Paragraph>
                            </div>

                            <div style={{ width: '350px' }}>
                              <FormGroup
                                error={
                                  errors?.listDepedentCondition?.[valueIndex]?.values?.[valueSubIndex]
                                    ?.dependentConditionValue?.label?.message
                                }>
                                <Paragraph className="label">Valor da condição dependente</Paragraph>
                                <Controller
                                  name={`listDepedentCondition.${valueIndex}.values.${valueSubIndex}.dependentConditionValue`}
                                  control={control}
                                  // eslint-disable-next-line react/jsx-no-bind
                                  render={({ field }) => renderSelectDependentCondition(field, valueIndex)}
                                />
                              </FormGroup>
                            </div>

                            <DialogConfirmAction
                              type="delete"
                              trigger={
                                <Button kind="outline" type="button">
                                  <XMarkIcon />
                                </Button>
                              }
                              title="Confirmar exclusão?"
                              text={`Tem certeza que deseja excluir essa relação?`}
                              // eslint-disable-next-line react/jsx-no-bind
                              onConfirm={() => removeDependentConditionAndValues(valueIndex, valueSubIndex)}
                            />
                          </section>
                        </Box>
                      ))}
                  </div>
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row-reverse',
                      justifyContent: 'space-between',
                      width: '100%',
                    }}>
                    <Button
                      type="button"
                      kind="outline"
                      style={{ width: '250px' }}
                      onClick={() => appendVinculo(valueIndex)}>
                      <PlusIcon />
                      Adicionar um vínculo.
                    </Button>
                    {valueIndex === fields.length - 1 && (
                      <Button type="button" kind="outline" style={{ width: '300px' }} onClick={appendValue}>
                        <PlusIcon />
                        Adicionar condição dependente.
                      </Button>
                    )}
                  </div>
                  {valueIndex !== fields.length - 1 && (
                    <div
                      className="condition-info"
                      style={{ height: '40px', padding: '0px', marginTop: '0px', marginBottom: '0px' }}></div>
                  )}
                </div>
              ))}
          </Box>
        </Box>
      </DynamicConditionContainer>
    </StyledFormDynamic>
  );
};

export default DynamicConditionForm;
